export default "__VITE_ASSET__B6PmELY3__"